import React, { useState, Fragment, useCallback } from 'react';

import AccordionAnimation, { AccordionElementRef } from './AccordionAnimation/AccordionAnimation';
import Button from '../../../../../../_ui/_blocks/Buttons/Button/Button';
import Typography from '../../../../../../_ui/_blocks/Typography/Typography';

import styles from './FilterShowMore.module.css';

interface Props {
    displayLimit: number;
    children: React.ReactNode;
    className?: string;
}

// TODO: fix padding height issue

const FilterShowMore = ({ displayLimit, children, className }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleShowMore = () => setIsOpen((state) => !state);

    const childrenAsArray = React.Children.toArray(children);

    const permanentChildren = childrenAsArray.slice(0, displayLimit);
    const showMoreChildren = childrenAsArray.slice(displayLimit);

    const label = isOpen ? 'Show less' : 'Show more';

    const openedCallback = useCallback((ref: AccordionElementRef) => {
        const focusableElements =
            ref.current?.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])') || [];
        if (focusableElements.length) {
            // @ts-ignore
            focusableElements[0].focus();
        }
    }, []);

    if (!displayLimit || childrenAsArray.length <= displayLimit) {
        return <ul className={className}>{children}</ul>;
    }

    return (
        <Fragment>
            <ul className={className}>{permanentChildren}</ul>
            <AccordionAnimation isOpen={isOpen} duration={400} openedCallback={openedCallback}>
                <ul className={className}>{showMoreChildren}</ul>
            </AccordionAnimation>
            <Button title={label} variant="none" size="none" onClick={toggleShowMore} className={styles.button}>
                <Typography typeset="link" size="080" weight='400'>{label}</Typography>
            </Button>
        </Fragment>
    );
};

export default FilterShowMore;
